module.exports = __webpack_public_path__ + "static/media/california-poppy.8670eddd.jpg";